import React, { FC, useState, useEffect } from 'react';
import DropDown from './components/dropdown';
import { TDynamicDropDownProps, TDynamicDropDown, TSelectedDropDownValue } from '../../../types/dynamicDropDown.types';
import './styles.scss';

const DynamicDropDown: FC<TDynamicDropDownProps> = (props) => {
    const { handleOptionClick, sendData } = props;
    const [selectedValue, setSelectedValue] = useState<TSelectedDropDownValue[]>(sendData);

    useEffect( () => {
        if (selectedValue[0].itemId !== '') {
            handleOptionClick(selectedValue);
        }
    }, [selectedValue]);

    useEffect( () => {
        if (sendData.length !== selectedValue.length) {
            setSelectedValue(sendData);
        }
    }, [sendData]);


    const renderDropdowns = (dynamicDropDown: TDynamicDropDown, index: number) => {
        const { dropdownOptions = [], label, isEnabled, id, fields, furtherDropdowns } = dynamicDropDown;
        const { hasFurtherDropdowns, dropDown } = furtherDropdowns;
        if (hasFurtherDropdowns && dropDown) {
            return (
                <>
                    <DropDown
                        dropdownOptions={dropdownOptions}
                        label={label}
                        isEnabled={isEnabled}
                        id={id}
                        fields={fields}
                        selectedValue={selectedValue}
                        dropdownIndex={index}
                        setSelectedValue={setSelectedValue}
                    />
                    {
                        renderDropdowns(dropDown, index + 1)
                    }
                </>
            )
        }
        return (
            <DropDown
                dropdownOptions={dropdownOptions}
                label={label}
                isEnabled={isEnabled}
                id={id}
                fields={fields}
                selectedValue={selectedValue}
                dropdownIndex={index}
                setSelectedValue={setSelectedValue}
            />
        )
    }


    return (
        <div className="sitecore-jss-form__control--dynamic-dropdown">
            {
                renderDropdowns(props.dropDown, 0)
            }
        </div>
    );
}

export default DynamicDropDown;